/**
 * @name results.controller:LinkTrigger
 * @description
 * # LinkTrigger
 * Add click handler for element, that set window.location.pathname with a value of
 * element's data-href.
 */
export default function ($scope, $element, CommonFunctions) {
    'ngInject';

    /**
     * Initial target for element
     * @type {string}
     */
    $scope.currentScreenSize = null;

    /**
     * Adding or removing .js-popuplink when screen size is changing
     * return 'extraNarrow' or 'narrow'
     */
    $scope.togglePopupClass = () => {
        $scope.currentScreenSize = CommonFunctions.getScreenSize();
        if ($scope.currentScreenSize === 'extraNarrow' ||
        $scope.currentScreenSize === 'narrow') {
            $element.addClass('js-popupLink');
        } else {
            $element.removeClass('js-popupLink');
        }
    };

    /**
     * Add click handler for element
     */
    $scope.init = () => {
        $element.on('click', $scope.togglePopupClass);
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/linkTrigger.js